import { useCustomer } from "@/modules/clients/hooks/use-customer.hook";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  buildWhatsappLink,
  resolveCustomerContact,
} from "@/modules/common/utils/customer-contact";

export interface OpenProposalInWhatsappProps extends BuildFileURLProps {
  customerUId: string;
}

interface BuildFileURLProps {
  trackUid: string | undefined;
  rootVersion: number;
  minorVersion: number;
}
export default function useOpenInWhatsapp({
  customerUId,
  trackUid,
  rootVersion,
  minorVersion,
}: OpenProposalInWhatsappProps) {
  const buildFileURL = (): string =>
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/tracks/${trackUid}/rental-proposal?v=${rootVersion}.${minorVersion}`;
  const { data: customer, isLoading } = useCustomer({ uid: customerUId });

  const contact = resolveCustomerContact(
    customer?.telephones,
    customer?.doNotCall,
  );
  const canOpenWhatsapp =
    !!customer && !!trackUid && !!buildWhatsappLink(contact);
  const disabledReason = !customer
    ? "Customer unavailable"
    : !trackUid
      ? "Proposal unavailable"
      : contact.kind === "hidden"
        ? "Contact details are hidden"
        : "No contact details";

  const handleWhatsapp = () => {
    if (isLoading || !canOpenWhatsapp || !customer) return;

    const message = `Hello ${customer.name},

Here’s your financial proposal for the requested property.
Please review it at your convenience, and I’m available if you’d like to walk through it together.

${buildFileURL()}`;

    const link = buildWhatsappLink(contact, message);
    if (link) window.open(link, "_blank", "noopener,noreferrer");
  };

  return { handleWhatsapp, isLoading, canOpenWhatsapp, disabledReason };
}
